<template>
  <div id="UserLayout">
    <a-layout style="min-height: 100vh">
      <a-layout-header class="header">
        <a-space>
          <img src="../assets/logo.png" class="logo" />
          <div>AIdati AI答题应用系统</div>
        </a-space>
      </a-layout-header>
      <a-layout-content class="content">
        <!-- 路由视图组件 -->
        <!-- 用于渲染当前路由路径对应的组件 -->
        <router-view />
      </a-layout-content>
      <a-layout-footer class="footer">
        <a target="_blank"> by zxq </a>
      </a-layout-footer>
    </a-layout>
  </div>
</template>
<script setup lang="ts"></script>
<style scoped>
#UserLayout {
  text-align: center;
  background: url("https://gw.alipayobjects.com/zos/rmsportal/FfdJeJRQWjEeGTpqgBKj.png")
    0% 0% / 100% 100%;
}
#UserLayout .logo {
  width: 47px;
  height: 47px;
}
/* 头部样式与底部间距和阴影效果 */
#UserLayout .header {
  margin-top: 20px;
  font-size: 20px;
}

#UserLayout .content {
  margin-bottom: 10px;
  padding: 20px;
}
#UserLayout .footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  background: #efefefef;
  text-align: center;
  padding: 10px;
}
</style>
